import { render } from "./MaintenancesTab.vue?vue&type=template&id=3d230f3e&ts=true"
import script from "./MaintenancesTab.vue?vue&type=script&lang=ts"
export * from "./MaintenancesTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__